import BaseModel from './BaseModel'

export default class ConseillerModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID: '',
      PRENOM: '',
      NOM: '',
      CODE_REF_CIVILITE: '',
      TELEPHONE: '',
      MOBILE: '',
      EMAIL: '',
      SIGNATURE_MAIL: '',
      URL_PRISE_DE_RENDEZ_VOUS: ''
    }
    super(data, relation, fields)
  }
}
